export default __webpack_public_path__ + "static/media/custom-white.2b52d705.svg";